export const DEFAULT_LEVELS = [
  { level: 1, name: 'Product' },
  { level: 2, name: 'Product Area' },
  { level: 3, name: 'Module' },
];

export const TREE_CONSTANTS = {
  MAX_LEVELS: 5,
  FEATURE_LEVEL: 'Features',
};

export const FEATURE_NODE_LEVEL = 0;

export const TAXONOMY_TITLES = {
  BUILDER: 'Taxonomy Builder',
};
